import React, { useEffect, useState, createRef } from 'react'
import { Container, Row, Col, Form, Card, Button } from 'react-bootstrap'
import Swal from 'sweetalert2'
import Select from "react-select"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { createUser } from '../../actions/usersActions'
import towns from '../../components/towns.json'
import provinces from '../../components/provinces.json'
import values from '../../components/values.json'
import services from '../../components/services.json'
import lines from '../../components/lines.json'

import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import { useNavigate } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'

export default function CreateSchool() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {client} = useAuth()

    const fileRef = createRef("<HTMLInputElement>")
    const {school} = useSelector(state=>state.schools)
    const {resultuser} = useSelector(state=>state.users)

    const [formState, setFormState] = useState({
        profile: "School",
        active_first: true,
        multiSchool: client?.id
    })

    const [provinceAux, setProvinceAux] = useState({label: '', value: ''});
    const [townAux, setTownAux] = useState({label: '', value: ''});
    const [townsAux, setTownsAux] = useState([]);
    const [imageAux, setImage] = useState(null)

    const [valuesSelect, setValuesSelect] = useState({options: values?.map(value => {
        return {label: t('values.'+value), value: value}
    }), selected : []})

    const [servicesSelect, setServicesSelect] = useState({options: services?.map(service => {
        return { label: t('services.' + service), value: service }
    }), selected: []})

    const [linesSelect, setLinesSelect] = useState({options: lines?.map(line => {
        return { label: t('school.lines.' + line), value: line }
    }), selected: []})

	const changeImage = (e) => {
		setImage(e.target.files[0])
	}


    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSelectTownChange = (target)=>{
        setFormState({
            ...formState,
            'town': target.value
        })
        setTownAux(towns.filter(town => town.value === target.value && formState.province === town.parent_value))

    }
    const [schoolTypeSelect, setSchoolTypeSelect] = useState({
        options: [
            { label: t('school.typeschool.charter'), value: 'charter' },
            { label: t('school.typeschool.private'), value: 'private' }
        ],
        selected: { label: '', value: '' }
    })

    const [biographyEditorState, setBiographyEditorState] = useState(EditorState.createEmpty())


    const handleSelectProvinceChange = (target)=>{
        setFormState({
            ...formState,
            'province': target.value,
            'town': ''
        })
        setProvinceAux(provinces.filter(province => province.value === target.value))
        setTownAux({label: '', value: ''})
        setTownsAux(towns.filter(town => town.parent_value === target.value))
    }

    const handleSelectValuesChange = (values) =>{
        if(values.length < 6){
            setValuesSelect({...valuesSelect, selected: values})
            setFormState({
                ...formState,
                'values': values.map(valor => {
                    return valor.value
                })
            })
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.maxvaluesselected')
            })
        }
    }

    const handleSelectServicesChange = (services) =>{
        setServicesSelect({...servicesSelect, selected: services})
        setFormState({
            ...formState,
            'services': services.map(service => {
                return service.value
            })
        })
    }

    const handleSelectLinesChange = (lines) =>{
        setLinesSelect({...linesSelect, selected: lines})
        setFormState({
            ...formState,
            'lines': lines.map(line => {
                return line.value
            })
        })
    }

    const handleSelectSchoolTypeChange = (selectedOption) => {
        setSchoolTypeSelect({ ...schoolTypeSelect, selected: selectedOption });
        setFormState({
            ...formState,
            'typeschool': selectedOption.value
        })
    }
    const handleAdd = async(e) => {
        e.preventDefault()

        if(formState.name !== null && formState.code !== null && formState.name !== '' && formState.code !== '' && formState.name !== undefined && formState.code !== undefined && formState.email !== null && formState.email !== '' && formState.email !== undefined && formState.password !== null && formState.password !== '' && formState.password !== undefined){
            dispatch(createUser(imageAux, formState))
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.pleasecomplete')
            })
        }
    }

    const handlebiographyChange = (biography) => {
        setBiographyEditorState(biography)

        setFormState({
            ...formState,
            biography: draftToHtml(convertToRaw(biography.getCurrentContent()))
        })
    }

    useEffect(() => {
        if (resultuser) {
            dispatch({
                type: 'USER_RESET_RESULT'
            })
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.dashboard.addSchoolSuccess')
                    })
                    navigate('/multischool/schools')
                    break
                default:
                    break
            }
        }
        // eslint-disable-next-line
    }, [resultuser, dispatch])

    return (
        <>
        	<Container className='cuerpo'>
				<Row>
                    <h1>{t('profile.school.profile')} {school?.name}</h1>
				</Row>
				<Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
                                <Form onSubmit={handleAdd}>
                                    <Row className="mt-3 mb-4">
                                        <Col xs='12' className='d-flex align-items-center'>
                                            <div className='avatar me-2'>
                                                {imageAux
                                                    ?
                                                        <img className="img-profile" alt="Preview" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} />
                                                    :
                                                        formState.image
                                                            ?
                                                                <img className="img-profile" alt="Preview" src={typeof formState.image === 'string' ? formState.image : URL.createObjectURL(formState.image)} />
                                                            :
                                                                <img className='img-profile' alt="Avatar" src="/images/avatar-empty.svg" />
                                                }
                                                <input
                                                    className='custom-file-input'
                                                    style={{ display: 'none' }}
                                                    ref={fileRef}
                                                    type="file"
                                                    name="myImage"
                                                    onChange={changeImage}
                                                />
                                            </div>
                                            <div className="cursor" onClick={() => fileRef?.current?.click()}>{t('users.image')}</div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className='mb-2'>
                                            <Form.Label htmlFor='typeschool'>{t('school.typeschool.title')}</Form.Label>
                                            <Select
                                                className='select'
                                                name='typeschool'
                                                value={schoolTypeSelect.selected}
                                                options={schoolTypeSelect.options}
                                                onChange={handleSelectSchoolTypeChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='name'>{t('users.name')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='name'
                                                value={formState.name ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='code'>{t('users.code')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='code'
                                                value={formState.code ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="mt-2 mb-0">
                                            <Form.Label htmlFor='province'>{t('users.province')}</Form.Label>
                                            <Select
                                                className="select"
                                                name={'province'}
                                                options={provinces.sort((a, b) => {
                                                        if (a.label < b.label) {
                                                            return -1
                                                        }
                                                        if (a.label > b.label) {
                                                            return 1
                                                        }
                                                        return 0
                                                    })}
                                                value={provinceAux || null}
                                                onChange={(e) => handleSelectProvinceChange(e)}
                                            />
                                            <input
                                                tabIndex={-1}
                                                autoComplete="off"
                                                style={{ opacity: 0, height: 0 }}
                                                value={formState.province || ''}
                                                readOnly
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="mt-2 mb-0">
                                            <Form.Label htmlFor='town'>{t('users.town')}</Form.Label>
                                            <Select
                                                className="select"
                                                name={'town'}
                                                options={townsAux}
                                                value={townAux || null}
                                                onChange={(e) => handleSelectTownChange(e)}
                                            />
                                            <input
                                                tabIndex={-1}
                                                autoComplete="off"
                                                style={{ opacity: 0, height: 0 }}
                                                value={formState.town || ''}
                                                readOnly
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="mt-0 mb-2">
                                            <Form.Label>{t('users.address')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='address'
                                                value={formState.address ||  ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="mt-0 mb-2">
                                            <Form.Label>{t('users.phone')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='phone'
                                                value={formState.phone ||  ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='values'>{t('users.choosevalues')}</Form.Label>
                                            <Select
                                                className="select"
                                                name='values'
                                                options={valuesSelect?.options}
                                                value={valuesSelect?.selected?.sort((a, b) => {
                                                        if (a.label < b.label) {
                                                            return -1
                                                        }
                                                        if (a.label > b.label) {
                                                            return 1
                                                        }
                                                        return 0
                                                    })}
                                                onChange={handleSelectValuesChange}
                                                isMulti
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='services'>{t('users.chooseservices')}</Form.Label>
                                            <Select
                                                className="select"
                                                name='services'
                                                options={servicesSelect?.options}
                                                value={servicesSelect?.selected}
                                                onChange={handleSelectServicesChange}
                                                isMulti
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='lines'>{t('users.chooselines')}</Form.Label>
                                            <Select
                                                className="select"
                                                name='lines'
                                                options={linesSelect?.options}
                                                value={linesSelect?.selected}
                                                onChange={handleSelectLinesChange}
                                                isMulti
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label>{t('signin.email')}</Form.Label>
                                            <Form.Control
                                                type='email'
                                                name='email'
                                                value={formState.email ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label>{t('signin.password')}</Form.Label>
                                            <Form.Control
                                                type='password'
                                                name='password'
                                                value={formState.password ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label>{t('users.havelinkedin')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='linkedin'
                                                value={formState.linkedin ||  ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="my-2">
                                            <Form.Label htmlFor='biography'>{t('users.biographyschool')}</Form.Label>
                                            <Editor
                                                name='biography'
                                                toolbar={{
                                                    options: ['inline', 'list', 'textAlign', 'link'],
                                                    inline: { options: ['bold', 'italic', 'underline'] },
                                                    list: { options: ['unordered', 'ordered'] },
                                                    textAlign: { options: [] },
                                                    link: { options: ['link', 'unlink'] }
                                                }}
                                                editorState={biographyEditorState}
                                                onEditorStateChange={handlebiographyChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3 d-flex justify-content-end">
                                        <Col xs='12' lg='4'>
                                            <Button type="submit" className="btn-primary w-100 my-2">{t('admin.dashboard.createSchool')}</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
						</Card>
					</Col>
				</Row>
			</Container>
        </>
    )
}